<template>
    <div class="common__page__box main__voice__bank__page">
        <div class="rlms-container">
            <section class="learner__assessments__filter__box voice__bank">
                <div class="back__btn">
                    <RouterLink
                        :to="{ name: 'LearnerDashboard', params: { organization: organizationId, learner: learnerId } }">
                        <span class="btn__icon">
                            <img :src="backBtnIcon" />
                        </span>
                        <span class="btn__text">Back</span>
                    </RouterLink>
                </div>
                <div class="main__title">
                    <h3 class="title">Voice Bank</h3>
                </div>
                <div class="page__tabs__links">
                    <ul id="tabs-nav">
                        <li v-for="group in assessmentGroups" :key="group.id"
                            :class="{ active: activeTab === group.tab }" @click="switchTab(group)">
                            <a href="javascript:void(0)" v-if="group.id != 6">{{ group.name }}</a>
                        </li>
                    </ul>
                </div>
                <div class="title__select__box">
                    <select class="select" @change="handleAssessmentChange">
                        <option value="">All</option>
                        <option v-for="(id, index) in assessmentIds" :key="id" :value="id"
                            :selected="assessmentId === id">
                            Assessment #{{ assessmentIds?.length - index }}
                        </option>
                    </select>
                </div>
            </section>
            <section class="learner__data__content__box">
                <div class="inner__cover__box">
                    <div class="sidebar__section__box">
                        <div class="profile__widget__box">
                            <div class="user__profile__img">
                                <img :src="learnerIcon">
                            </div>
                            <h5 class="title">{{ learner?.firstname }} {{ learner?.lastname }}</h5>
                            <div class="user__personal__info">
                                <div class="info__box__wrapper">
                                    <label class="label">Date of Birth</label>
                                    <span class="location">{{ formatDate(learner?.dob) }}</span>
                                </div>
                            </div>
                            <div class="learner__edit__btn" v-if="learner?.is_owner || learner?.is_administrator">
                                <a href="javascript:void(0)" @click="showEditLearnerModal = true">
                                    <span class="btn__icon">
                                        <img :src="editIcon">
                                    </span>
                                    <span class="btn__text">Edit Learner</span>
                                </a>
                            </div>
                        </div>
                        <div class="btn__widget__box">
                            <div class="purple__solid__btn">
                                <RouterLink
                                    :to="{ name: 'LearnerVoiceBankTestItem', params: { organization: organizationId, learner: learnerId } }">
                                    View By Test Item</RouterLink>
                            </div>
                        </div>
                    </div>
                    <div class="main__data__content__box tab-content" id="tab1" style="">

                        <template v-for="group in assessmentGroups" :key="group.tab">
                            <template v-if="activeTab === group.tab && group.id !== 6">
                                <div class="head__title__box">
                                    <div class="head__title test__head__item">Test Item</div>
                                    <div class="head__title date__head__item">Date</div>
                                    <div class="head__title time__head__item">Time (Length)</div>
                                    <div class="head__title action__head__item">Action</div>
                                </div>
                                <div class="divider__sepline"></div>
                                <div class="audio__content__box">
                                    <div class="audio__data__row" v-for="audio in voiceBank" :key="audio.id">

                                        <div class="audio__test__box audio__data__item">
                                            <span><strong>{{ audio?.question?.question }}</strong></span>
                                            <span> {{ formatConsonants(audio?.question?.consonant) }} </span>
                                        </div>
                                        <div class="audio__date__box audio__data__item">
                                            {{ formatDate(audio.updated_at) }}
                                        </div>
                                        <div class="audio__time__length audio__data__item">
                                            <span class="time">{{ formatDuration(audio.duration) }}</span>
                                        </div>
                                        <div class="play__audio__btn audio__data__item">
                                            <div class="playaudiobtn">
                                                <a href="javascript:void(0)" @click="selectedItem = audio">
                                                    <span class="play__icon">
                                                        <img :src="playIcon">
                                                    </span>

                                                </a>
                                            </div>
                                            <div class="playaudiobtn">
                                                <a href="javascript:void(0)"
                                                    @click="removeAudio(audio.aid, audio.id, audio?.assessment?.can_edit)">
                                                    <span class="play__icon">
                                                        <img :src="removeIcon" alt="Remove Icon">
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-if="!voiceBank.length">
                                        <div class="no__learner__assessment__block">
                                            <div class="inner__content__block" style="height: 300px">
                                                <div class="title__block__wrap">
                                                    <h4 class="title">
                                                        <p>No voice recordings available for this group.</p>
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </template>
                        <paginate v-model="page" :page-count="totalPages" :margin-pages="2" :prev-text="'<'"
                            :next-text="'>'" :container-class="'pagination'" :page-class="'page-item'"
                            :active-class="'active-page'" v-if="totalItems > 0" />
                    </div>
                </div>
            </section>
        </div>
        <AddEditLearnerModal v-if="showEditLearnerModal" @close="showEditLearnerModal = false;" @saved="init()"
            :organizationId="organizationId" :learner="learner" />
        <PlayAudioModal v-if="selectedItem" :item="selectedItem" @close="selectedItem = null" />
    </div>
</template>
<script setup>
import AddEditLearnerModal from '@/components/AddEditLearnerModal.vue';
import PlayAudioModal from '@/components/PlayAudioModal.vue';
import api from '@/services/axios';
import { useLoaderStore } from '@/stores/loader';
import { assessmentGroups } from '@/utils/assessmentGroups';
import { formatConsonants, formatDate, formatDuration } from '@/utils/format-helpers';
import { handleError } from '@/utils/handleError';
import { showConfirmDialog, showDialog } from '@/utils/swal';
import { onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import paginate from 'vuejs-paginate-next';
import confirmationIcon from '@/assets/images/confirmation.png';
import backBtnIcon from '@/assets/images/back-btn-icon.png';
import learnerIcon from '@/assets/images/learner-icon.png';
import editIcon from '@/assets/images/edit.svg';
import playIcon from '@/assets/images/audio/transcribe/play.png';
import removeIcon from '@/assets/images/remove-icon1.png'
import { authrizedPermissions } from '@/utils/permissions';


const router = useRouter();
const route = useRoute();

const organizationId = ref(Number(route.params.organization ?? 0));
const learnerId = ref(Number(route.params.learner ?? 0));
const assessmentId = ref(Number(route.params.assessment ?? ''));
const learner = ref(null);
const organization = ref(null);
const assessmentIds = ref([]);
const voiceBank = ref([]);
const page = ref(1);
const totalPages = ref(1);
const totalItems = ref(0);
const selectedItem = ref(null);
const showEditLearnerModal = ref(false);
const groupId = ref(1);
const activeTab = ref('tab1');
const loader = useLoaderStore();

onMounted(async () => {
    init();
});

const init = () => {
    showEditLearnerModal.value = false;
    voiceBank.value = [];
    fetchLearner();
}

const fetchLearner = async () => {
    try {
        loader.show();
        const { data } = await api.get(`/organizations/${organizationId.value}/learners/${learnerId.value}/voicebank`, {
            params: {
                group: groupId.value,
                page: page.value,
                per_page: 25,
                aid: assessmentId.value
            }
        });

        learner.value = data?.data?.learner;
        voiceBank.value = data?.data?.voicebanks?.data;
        assessmentIds.value = data?.data?.assessmentIds;
        organization.value = learner.value?.organization;

        totalPages.value = data?.data?.voicebanks?.last_page;
        totalItems.value = data?.data?.voicebanks?.total;
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
};

const removeAudio = async (aid, attemptid, canEdit = true) => {
    if (!canEdit) {
        let message = `You don’t have permission perform this action.`;

        if (learner.value?.is_administrator) {
            message = `You don’t have permission to delete this assessment because it was created before you were granted administrator access.`;
        } else if (learner.value?.is_authorized_user) {
            if (learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `You don’t have permission to delete this assessment because it was created before you were granted group access.`;
            } else if (!learner.value?.permissions?.[authrizedPermissions.conduct_view_assessments]) {
                message = `Assessment available to you through group access. You don’t have permission perform this action.`;
            }
        }
        
        showDialog({ icon: 'warning', html: message });
        return;
    }

    try {
        const result = await showConfirmDialog({
            title: 'Are you sure?',
            html: '<p id="text-message">You want to remove the voice bank learner assessment record.</p>',
            confirmButtonText: 'Confirm',
            imageUrl: confirmationIcon
        });

        if (result.isConfirmed) {
            loader.show();

            await api.post(`/organizations/${organizationId.value}/assessments/${aid}/attempt`, {
                attemptid,
                remove_audio: 1,
                duration: null
            });

            fetchLearner();
        }
    } catch (error) {
        handleError(error);
    } finally {
        loader.hide();
    }
}

const handleAssessmentChange = (event) => {
    const selectedId = event.target.value;
    if (selectedId && selectedId !== assessmentId.value) {
        router.push({ name: 'LearnerAssessmentVoiceBank', params: { organization: organizationId.value, learner: learnerId.value, assessment: selectedId } });
    }

    if (selectedId == '' && assessmentId.value != '') {
        router.push({ name: 'LearnerVoiceBank', params: { organization: organizationId.value, learner: learnerId.value } });
    }
};

// Tab switch
function switchTab(group) {
    activeTab.value = group.tab;
    groupId.value = group.id;

    if (group.id === 6) {
        return;
    }
}

watch(groupId, () => {
    init();
});

watch(page, () => {
    fetchLearner();
});

watch(route, ({ params }) => {
    organizationId.value = params.organization;
    learnerId.value = params.learner;
    assessmentId.value = params.assessment;
    fetchLearner();
    activeTab.value = 'tab1';
}, { deep: true });
</script>